import {
  AnalyticsIcon,
  CloseIcon,
  HamburgerIcon,
  HomeIcon,
  IntegrationIcon,
  ProductsIcon,
  SegmentIcon,
} from 'components/icons';
import {
  NavigationLink,
  NavigationLinkMultiMenu,
  StoreSelector,
  UserAvatar,
} from 'components/sidebar';
import { omit } from 'lodash';
import querystring from 'querystring';
import { useState } from 'react';
import { useParseURLQueryParams } from 'utils';
import { useStoreSubscriptionPlan } from 'utils/useStoreSubscriptionPlan';

export default function NavBarMobile() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { serializedStoreName, rawQueryParams } = useParseURLQueryParams();

  const { subscriptionPlans } = useStoreSubscriptionPlan();

  const dateString = new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
  const timeString = new Date().toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });

  return (
    <div
      className={`z-10 w-full flex flex-col justify-between ${
        menuOpen && 'h-screen'
      }`}
    >
      <div>
        <div className={`p-5 bg-segments-dark ${menuOpen && 'rounded-b-3xl'}`}>
          <div className="flex justify-between">
            <img
              src="/assets/logo-segments.png"
              alt="logo"
              className="w-7 h-7"
            />
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="focus:outline-none"
            >
              {menuOpen ? (
                <CloseIcon className="w-6 h-6 text-white" />
              ) : (
                <HamburgerIcon className="w-6 h-6 text-white" />
              )}
            </button>
          </div>
          {menuOpen && (
            <div className="flex items-center mt-3 space-x-5">
              <StoreSelector fullSize mobile />
            </div>
          )}
        </div>
        {menuOpen && (
          <ul className="mx-1 mt-6">
            <li className="border-b" onClick={() => setMenuOpen(!menuOpen)}>
              <NavigationLink
                fullSize
                iconsColor="black"
                icon={HomeIcon}
                to={{
                  pathname: '/dashboard',
                  search: String(serializedStoreName),
                }}
              >
                Dashboard
              </NavigationLink>
            </li>
            <li className="border-b">
              <NavigationLinkMultiMenu
                fullSize
                iconsColor="black"
                icon={IntegrationIcon}
                mainMenu="Integrations"
                subMenus={[
                  {
                    name: 'My integrations',
                    pathname: '/integrations',
                    search: String(serializedStoreName),
                    callback: () => setMenuOpen(!menuOpen),
                  },
                  {
                    name: '+ Connect new',
                    pathname: '/integrations/connect',
                    search: String(serializedStoreName),
                    callback: () => setMenuOpen(!menuOpen),
                  },
                ]}
              />
            </li>
            <li className="border-b">
              <NavigationLinkMultiMenu
                fullSize
                iconsColor="black"
                icon={SegmentIcon}
                mainMenu="Segments"
                subMenus={[
                  {
                    name: 'My segments',
                    pathname: '/customers/segments',
                    search: String(serializedStoreName),
                    callback: () => setMenuOpen(!menuOpen),
                  },
                  {
                    name: '+ Create new',
                    pathname: '/customers/create',
                    callback: () => setMenuOpen(!menuOpen),
                    search: querystring.stringify({
                      ...omit({ ...rawQueryParams }, [
                        'start_date',
                        'end_date',
                      ]),
                    }),
                  },
                ]}
              />
            </li>
            <li className="border-b">
              <NavigationLinkMultiMenu
                fullSize
                iconsColor="black"
                icon={AnalyticsIcon}
                mainMenu="Analytics"
                subMenus={[
                  {
                    name: 'Executive summary',
                    pathname: '/analytics/summary',
                    search: String(serializedStoreName),
                    callback: () => setMenuOpen(!menuOpen),
                  },
                  {
                    name: 'Purchase timing',
                    pathname: '/analytics/purchase-timing',
                    search: String(serializedStoreName),
                    subscriptionAccess: subscriptionPlans.small_business,
                    callback: () => setMenuOpen(!menuOpen),
                  },
                  {
                    name: 'Customer cohorts',
                    pathname: '/analytics/cohort',
                    search: String(serializedStoreName),
                    subscriptionAccess: subscriptionPlans.small_business,
                    callback: () => setMenuOpen(!menuOpen),
                  },
                ]}
              />
            </li>
            <li className="border-b">
              <NavigationLinkMultiMenu
                fullSize
                iconsColor="black"
                icon={ProductsIcon}
                mainMenu="Products"
                subMenus={[
                  {
                    name: 'Product journey',
                    pathname: '/products/product-journey',
                    search: String(serializedStoreName),
                    subscriptionAccess: subscriptionPlans.growth,

                    callback: () => setMenuOpen(!menuOpen),
                  },
                  {
                    name: 'Product relations',
                    pathname: '/products/product-relations',
                    search: String(serializedStoreName),
                    subscriptionAccess: subscriptionPlans.growth,

                    callback: () => setMenuOpen(!menuOpen),
                  },
                ]}
              />
            </li>
          </ul>
        )}
      </div>
      {menuOpen && (
        <div className="flex flex-col items-center p-3 mb-2">
          <UserAvatar fullSize mobile />

          <p className="pt-2 font-bold text-black uppercase truncate text-segments-13px text-opacity-30">
            {timeString} | {dateString}
          </p>
        </div>
      )}
    </div>
  );
}
